var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, ButtonGroup } from 'Components.Form';
import { CompletedStep, ProcessStep } from 'Components.Structure';
import { FormattedMessage } from 'Intl';
var ProcessStepButtonGroup = styled(ButtonGroup)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: .5rem;\n"], ["\n  margin-bottom: .5rem;\n"])));
var YesNoProcessStep = function (_a) {
    var _b = _a.yesLabel, yesLabel = _b === void 0 ? undefined : _b, _c = _a.noLabel, noLabel = _c === void 0 ? undefined : _c, _d = _a.completedYesSubtitle, completedYesSubtitle = _d === void 0 ? 'Selected Yes' : _d, _e = _a.completedNoSubtitle, completedNoSubtitle = _e === void 0 ? 'Selected No' : _e, _f = _a.defaultChoice, defaultChoice = _f === void 0 ? undefined : _f, _g = _a.baseId, baseId = _g === void 0 ? undefined : _g, props = __rest(_a, ["yesLabel", "noLabel", "completedYesSubtitle", "completedNoSubtitle", "defaultChoice", "baseId"]);
    var _h = useState(false), confirmed = _h[0], setConfirmed = _h[1];
    var _j = useState(defaultChoice), yesNo = _j[0], setYesNo = _j[1];
    return (React.createElement(ProcessStep, { baseId: baseId, confirmed: confirmed, label: props.label, subtitle: props.subtitle, onEditStep: function () {
            props.onEdit();
            setConfirmed(!confirmed);
        }, confirmDisabled: yesNo == null, onConfirm: function () {
            if (yesNo == null)
                return;
            setConfirmed(!confirmed);
            props.onConfirm(yesNo);
        }, confirmedContent: (React.createElement(React.Fragment, null, yesNo != null && (React.createElement(CompletedStep, { title: yesNo
                ? yesLabel || (React.createElement(FormattedMessage, { id: 'common.yes' }))
                : noLabel || (React.createElement(FormattedMessage, { id: 'common.no' })), subtitle: yesNo ? completedYesSubtitle : completedNoSubtitle })))), activeContent: (React.createElement(ProcessStepButtonGroup, null,
            React.createElement(Button, { id: "".concat(baseId, "_yes_button"), primary: yesNo != null && yesNo, onClick: function () { return setYesNo(true); } }, yesLabel || (React.createElement(FormattedMessage, { id: 'common.yes' }))),
            React.createElement(Button, { id: "".concat(baseId, "_no_button"), primary: yesNo != null && !yesNo, onClick: function () { return setYesNo(false); } }, noLabel || (React.createElement(FormattedMessage, { id: 'common.no' }))))) }));
};
export default YesNoProcessStep;
var templateObject_1;
